import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements  HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(environment.apiUrl)) {
      let contentType = 'application/x-www-form-urlencoded';

      if (req.body && typeof req.body === 'object' && !(req.body instanceof HttpParams)) {
        contentType = 'application/json';
      }

      const clonedReq = req.clone({
        setHeaders: {
          Authorization: environment.authToken,
          'Content-Type': contentType
        }
      });
      return next.handle(clonedReq);
    }
    return next.handle(req);
  }
}
